import setCurrentPage from "src/Utils/setCurrentPage";
import UseCaseVideoPanel from "src/Components/Common/UseCaseVideoPanel";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_USE_CASE_4 = [
  {
    icon: "peopleInsideGear",
    iconColor: "white",
    text: `<b>360°</b> customer \njourney visibility`,
    listItemCustomStyle: { width: "248px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithPersonAndMessageBubble",
    iconColor: "white",
    text: `Reduced AHT \nby <b>50%</b>`,
    listItemCustomStyle: { width: "234px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "peopleWithCheckmarkAndMessageBubble",
    iconColor: "white",
    text: `Improve FCR \nby <b>15%</b>`,
    listItemCustomStyle: { width: "230px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const DATA_EV_DEMO_USE_CASE_4 = {
  headerRightText: "GET THE EDGE",
  headerLeftImage: "EdgeverveLogo.png",
  title: "Customer SERVICE",
  titleStyle: {
    marginTop: "-32px",
    fontSize: "100px",
    textTransform: "uppercase",
  },
  subtitle: "Use case 3",
  subtitleStyle: { color: "#92D1FF", fontSize: "24px", marginTop: "32px" },
  text: "Re-imagine and elevate your customer service \nexperience, powered by cutting-edge Automation \nand Gen-AI technology.",
  textStyle: { marginTop: "60px", marginBottom: "40px" },
  listData: LIST_DATA_USE_CASE_4,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(403),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "EV/EV_demo_Intro_07.png",
  rightSideComponent: (
    <UseCaseVideoPanel
      infoIconClick={() => {
        setPreviousPage(414);
        setCurrentPage(419);
      }}
      imageClick={() => setCurrentPage(415)}
      title="WATCH THE EXPLAINER VIDEO"
      image="EV/EV_demo_use_case_04.png"
    />
  ),
};

export default DATA_EV_DEMO_USE_CASE_4;
